import { useEffect } from 'react';
import type {
	BulkOperationsPubSubEvent,
	BulkOperationsPubSubPayload,
	BulkOperationsSubscriber,
} from './types.tsx';

class BulkOperationsPubSub {
	subscribers: Partial<Record<BulkOperationsPubSubEvent, BulkOperationsSubscriber[]>> = {};

	subscribe = (typename: BulkOperationsPubSubEvent, subscriber: BulkOperationsSubscriber) => {
		this.subscribers[typename] = [...(this.subscribers[typename] ?? []), subscriber];
		return () => {
			this.subscribers[typename] =
				this.subscribers[typename]?.filter((sub) => sub !== subscriber) ?? [];
		};
	};

	publish = (typename: BulkOperationsPubSubEvent, payload: BulkOperationsPubSubPayload) => {
		this.subscribers[typename]?.forEach((subscriber) => subscriber(payload));
	};
}

const bulkOperationsPubSub = new BulkOperationsPubSub();

export const publishBulkOperationsEvent = bulkOperationsPubSub.publish;

export const useSubscribeToBulkOperationsEvents = (
	event: BulkOperationsPubSubEvent | BulkOperationsPubSubEvent[],
	subscriber: BulkOperationsSubscriber,
) => {
	useEffect(() => {
		const eventNames = Array.isArray(event) ? event : [event];

		const unsubscribes = eventNames.map((e) => bulkOperationsPubSub.subscribe(e, subscriber));
		return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
	}, [event, subscriber]);
};
